import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { FormContainer } from '../../../../../components/Form/FormComponents';
import {
  AssignTemplateFieldTypes,
  useAssignTemplateFormsSchema,
} from '../../../../../schemas/template-assignment-schema';
import { captureFormValidationError } from '../../../../../util/SentryUtils';
import { StepperFormButtons } from '../../../../Finance2/Forms/StepperFormButtons';
import { AssignTemplateFields } from './AssignTemplateForm';
import { currentStepStateTAJ, templateAssignmentFormStateJ } from './AssignTemplateFormState';
import { useAtom } from 'jotai';

export function AssignTemplateStep1() {
  const [templateAssignmentDataState, setTemplateAssignmentDataState] = useAtom(templateAssignmentFormStateJ);
  const getAssignSchema = useAssignTemplateFormsSchema();
  const assignSchema = getAssignSchema(templateAssignmentDataState?.frequency);
  const methods = useForm<AssignTemplateFieldTypes>({
    defaultValues: templateAssignmentDataState ?? assignSchema.getDefault(),
    mode: 'all',
    resolver: yupResolver(assignSchema),
  });
  const handleSubmit = async () => {
    const isValid = await methods.trigger();
    if (!isValid) {
      captureFormValidationError('Assign template step 1', methods.formState.errors);
    }
    setTemplateAssignmentDataState(methods.getValues());
    return isValid;
  };

  return (
    <FormProvider {...methods}>
      <FormContainer>
        <AssignTemplateFields />
      </FormContainer>
      <StepperFormButtons stepIsValid={handleSubmit} stepState={currentStepStateTAJ} />
    </FormProvider>
  );
}
